// extracted by mini-css-extract-plugin
export var chip = "_5z-9";
export var chipLabel = "_5z-a";
export var close = "_5z-7";
export var closeIcon = "_5z-8";
export var error = "_5z-6";
export var infoTooltip = "_5z-2";
export var innerContainer = "_5z-1";
export var input = "_5z-b";
export var medium = "_5z-5";
export var outerContainer = "_5z-0";
export var small = "_5z-4";
export var xSmall = "_5z-3";